import { Create, Edit, List, Show, Barcode, UserIdCard } from "../Components/index.js";

export default [
    {
        path: "/visitor-profile",
        component: List,
        name: "visitor.profile",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/visitor-profile/barcode/:id",
        component: Barcode,
        name: "visitor.profile.barcode",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/visitor-profile/card",
        component: UserIdCard,
        name: "visitor.profile.card",
        meta: {
            requiresAuth: true,
        },
    },
    // {path: '/visitor/entry', component: Create, name: 'visitor.entry',

    {
        path: "/visitor-profile/:id/edit",
        component: Edit,
        name: "visitor.profile.entry.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/visitor-profile/:id/show",
        component: Show,
        name: "visitor.entry.profile.show",
        meta: {
            requiresAuth: true,
        },
    },
];
